const USER_KEY = 'user';
const TOKEN_KEY = 'token';

export const authService = {
  getUser: () => {
    try {
      const user = localStorage.getItem(USER_KEY);

      if (!user || user === 'undefined' || user === 'null') {
        return null;
      }

      return JSON.parse(user);
    } catch {
      return null;
    }
  },

  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  setUser: (user: any) => {
    if (user) {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(USER_KEY);
    }
  },

  setToken: (token: string | null) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  },

  removeUser: () => {
    localStorage.removeItem(USER_KEY);
  },

  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  clear: () => {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
  },
};
